import React from "react";

export const FacebookMessengerFilled = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 2C12.3008 2 2 11.6016 2 23.5C2 29.8008 4.89844 35.6992 10 39.8008V48.6016L18.6016 44.1016C20.6992 44.6992 22.8008 44.8984 25 44.8984C37.6992 44.8984 48 35.3008 48 23.3984C48 11.6016 37.6992 2 25 2ZM27.3008 30.6016L21.5 24.3984L10.6992 30.5L22.6992 17.8008L28.6016 23.6992L39.1016 17.8008L27.3008 30.6016Z"
        fill="currentColor"
      />
    </svg>
  );
};
